/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function (Flickity) {
    // RECAHRGE
    function shopifyAddToCart(el) {
        console.log("ADDED TO CART", el);
        let player = document.querySelector(".lottie-player");
        player.stop();
        player.play();

        var $el = $(el);
        var variantId = el.getAttribute("data-variant-id");
        var sellingPlanId = el.getAttribute("data-selling-plan-id");
        var redirectTo = $el.data("redirect-to");
        var qty = $el.data("qty");
        var type = $el.data("type");
        var noRedirect = $el.data("noredirect");
        var noteValue = "";
        var item = {};
        var data = [];
        item["id"] = variantId;
        item["quantity"] = qty;

        if (noRedirect !== 1) {
            $(".js-spinner").show();
        }

        if (sellingPlanId) {
            item["selling_plan"] = sellingPlanId;
        }

        if (type == "gift-purchase") {
            item["attributes"] = { recipient_email: $("#recipientEmail").val() };
        }

        if (type == "gift-card") {
            item["properties"] = Object.assign({}, item["properties"] || {}, {
                "__rc_gift_sender_name": $("#sender").val(),
                "__rc_gift_recipient_first_name": $("#first_name").val(),
                "__rc_gift_recipient_last_name": $("#last_name").val(),
                "__rc_gift_recipient_email": $("#email").val(),
                "__rc_gift_recipient_note": $("#message").val(),
            });
            noteValue = `${$("#message").val()}\n\nFrom: ${$("#sender").val()}`
        }

        data.push(item);
        const redirectToCheckout = () => {
            $(".js-spinner").hide();
            if (redirectTo) {
                window.location.href = redirectTo;
            } else {
                window.location.href = "/checkout";
            }
        };
        const onError = (xhr, status, err) => {
            $(".js-spinner").hide();
            alert("Something went wrong, please refresh the page and try again.");
            console.error(xhr, status, err);
        };
        const findWidget = (widgetId) => {
            if (typeof window.Rebuy === 'undefined' || !window.Rebuy.widgets || !Array.isArray(window.Rebuy.widgets)) {
                return null;
            }
            return window.Rebuy.widgets.find(w => w.id === String(widgetId) || w.id == widgetId) || null;
        };

        const openRebuyWidget = (widgetId) => {
            const widget = findWidget(widgetId);
            if (!widget) return false;
            
            if (widget.data?.config) {
                widget.data.config.popup_trigger = 'manual';
            }
            
            if (typeof widget.render === 'function') {
                widget.render();
                setTimeout(() => widget.show?.(), 100);
                return true;
            }
            
            if (typeof widget.show === 'function') {
                widget.show();
                return true;
            }
            
            return false;
        };

        const onSuccess = () => {
            $(".js-spinner").hide();
            if (el.getAttribute('data-hide-cart') === "1") {
                const SC = window.Rebuy?.SmartCart;
                console.log('SC:', SC);
                if (SC && !SC._originalShow) {
                    SC._originalShow = SC.show;
                }
                if (SC) SC.show = () => console.log("SmartCart show prevented");
            }
            
            const rebuyWidgetId = el.dataset.rebuyWidgetId;
            const shouldOpenWidget = rebuyWidgetId && findWidget(rebuyWidgetId);
            
            if (noRedirect !== 1) {
                if (shouldOpenWidget) {
                    const rebuyOpened = openRebuyWidget(rebuyWidgetId);
                    if (!rebuyOpened) {
                        redirectToCheckout();
                    }
                } else {
                    redirectToCheckout();
                }
            } else {
                $(el).text("Added to cart!");
                if (shouldOpenWidget) {
                    const rebuyOpened = openRebuyWidget(rebuyWidgetId);
                    if (!rebuyOpened) {
                        setTimeout(() => {
                            openRebuyWidget(rebuyWidgetId);
                        }, 500);
                    }
                }
            }
        };
        if (!variantId && !qty) {
            onError(null, null, "No variant or quantity provided");
            return;
        }
        if ($(".gift-note").length) {
            noteValue = $(".gift-note").val();
        }
        $.ajax({ type: "GET", dataType: "json", url: "/cart.js" })
            .done((cartData) => {
                const cartItemIds = [];
                if (cartData && cartData.items.length > 0) {
                    cartData.items.forEach((item) => {
                        cartItemIds.push(item.id);
                    });
                }
                if (cartItemIds.find((id) => id === variantId && noRedirect != 1)) {
                    redirectToCheckout();
                } else {
                    $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: { items: data, note: noteValue },
                        dataType: "json",
                    })
                        .done(() => {
                            if (type == "gilt") {
                                let giltBonus = document.createElement("a");
                                giltBonus.setAttribute("data-variant-id", "46458773536987");
                                giltBonus.setAttribute("data-qty", 1);
                                shopifyAddToCart(giltBonus);
                            } else if (type == "freegift") {
                                let freeGift = document.createElement("a");
                                freeGift.setAttribute("data-variant-id", el.getAttribute("data-freegift-variant-id"));
                                freeGift.setAttribute("data-qty", 1);
                                freeGift.setAttribute("data-noredirect", 1);
                                shopifyAddToCart(freeGift);
                            } else {
                                onSuccess();
                            }
                        })
                        .fail(onError);
                }
            })
            .fail(onError);
        // AJAX CALL ABOVE LOTTIE TIMING
        // setTimeout(() => {
        // }, 1200);
    }

    function waitForJquery(fn) {
        if (window.jQuery) {
            fn(window.jQuery);
        } else {
            setTimeout(function () {
                waitForJquery(fn);
            }, 100);
        }
    }

    waitForJquery(function ($) {
        $(document).ready(function () {
            console.log("jquery loaded");

            $(".btn-add-to-cart").each(function () {
                $(this)
                    .off("click")
                    .on("click", function (e) {
                        e.preventDefault();
                        shopifyAddToCart(this);
                    });
            });
            $(".btn-add-to-cart.checkout-button.checkout-popup").each(function () {
                $(this)
                    .off("click")
                    .on("click", function (e) {
                        e.preventDefault();
                        showModal(this);
                    });
            });
            $("#liteDialog button.x").on("click", function (e) {
                let dialog = document.getElementById("liteDialog");
                dialog.close();
            });
            $("#plusDialog button.x").on("click", function (e) {
                let dialog = document.getElementById("plusDialog");
                dialog.close();
            });
        });
    });

    // LIGHTBOX
    const lightbox = document.createElement("div");
    lightbox.id = "lightbox";
    document.body.appendChild(lightbox);

    const images = document.querySelectorAll("img.lightbox");
    images.forEach((image) => {
        image.addEventListener("click", (e) => {
            let imgsource = image.src.match(/(^.*)?\_/);
            lightbox.classList.add("active");
            const img = document.createElement("img");
            const caption = document.createElement("p");
            const title = document.createElement("h3");
            caption.innerHTML = image.alt;
            title.innerHTML = image.getAttribute("data-title");
            let alternative = image.getAttribute("data-alternative-src");
            if (alternative) {
                img.src = alternative;
            } else {
                img.src = imgsource[1] + ".jpg";
            }
            while (lightbox.firstChild) {
                lightbox.removeChild(lightbox.firstChild);
            }
            lightbox.appendChild(title);
            lightbox.appendChild(caption);
            lightbox.appendChild(img);
        });
    });

    const pdfs = document.querySelectorAll("a.past-box__pdf");
    pdfs.forEach((pdf) => {
        pdf.addEventListener("click", (e) => {
            lightbox.classList.add("active");
            const iPdf = document.createElement("iframe");
            iPdf.setAttribute("src", "https://cdn.flipsnack.com/widget/v2/widget.html?hash=" + pdf.id);
            iPdf.setAttribute("seamless", "seamless");
            iPdf.setAttribute("scrolling", "no");
            iPdf.setAttribute("frameBorder", "0");
            iPdf.setAttribute("width", "100%");
            iPdf.setAttribute("height", "100%");
            while (lightbox.firstChild) {
                lightbox.removeChild(lightbox.firstChild);
            }
            lightbox.appendChild(iPdf);
            const xButton = document.createElement("button");
            xButton.id = "lightboxClose";
            xButton.innerHTML = "X";
            lightbox.appendChild(xButton);
        });
    });

    lightbox.addEventListener("click", (e) => {
        if (e.target !== e.currentTarget) return;
        lightbox.classList.remove("active");
    });

    // FLOATING GET THE BOX BUTTON
    const getTheBoxButton = document.querySelector("[data-floating-button]");
    if (getTheBoxButton) {
        // getTheBoxButton.addEventListener("click", () => {
        //     console.log("clicked");
        // });
        document.addEventListener("theme:scroll", () => {
            getTheBoxButton.classList.toggle("is-visible", window.pageYOffset > window.innerHeight);
        });
    }

    // CHANGE NAV LINKS COLOR
    function changeNavColor(type) {
        let slider;

        if ($(".promo-banner").length) return;

        if (type == "gsa-hero") {
            slider = $(".gsa-hero-slider .slider .gsa-hero.is-selected .page-width .content h2");
        } else {
            slider = $(".bb-hero-slider .slideshow__slide.is-selected .hero__content .hero__title");
        }

        if (slider.css("color") == "rgb(51, 51, 51)") {
            $(".header__wrapper").removeClass("white");
        } else {
            $(".header__wrapper").addClass("white");
        }
    }

    var drawer = $(".drawer--header");
    var mutObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            var attributeValue = $(mutation.target).prop(mutation.attributeName);
            if (attributeValue.indexOf("is-open") != -1) {
                $(".header__wrapper").addClass("drawer-opened");
            } else {
                $(".header__wrapper").removeClass("drawer-opened");
            }
        });
    });

    mutObserver.observe(drawer[0], {
        attributes: true,
        attributeFilter: ["class"],
    });

    if (document.querySelector(".gsa-hero-slider .slider")) {
        var flkty = new Flickity(".gsa-hero-slider .slider", {
            cellAlign: "center",
            contain: true,
            pageDots: false,
            lazyLoad: 2,
            imagesLoaded: true,
            adaptiveHeight: true,
            on: {
                ready: function () {
                    changeNavColor("gsa-hero");
                },
                select: function () {
                    changeNavColor("gsa-hero");
                },
                change: function () {
                    changeNavColor("gsa-hero");
                },
            },
        });
    }

    if (document.querySelector(".bb-hero-slider")) {
        var flkty = new Flickity(".bb-hero-slider", {
            on: {
                ready: function () {
                    changeNavColor();
                },
                select: function () {
                    changeNavColor();
                },
                change: function () {
                    changeNavColor();
                },
            },
        });
    }

    //CUSTOM THUMBNAILS FLICKITY
    if ($(".slider .slider-main").length) {
        var subscribeSlider = new Flickity(".slider .slider-main", {
            contain: true,
            pageDots: false,
            lazyLoad: 2,
            imagesLoaded: true,
            draggable: false,
        });

        subscribeSlider.on("change", syncSlides);

        var subscribeSliderThumbs = new Flickity(".slider .slider-nav", {
            contain: true,
            pageDots: false,
            cellAlign: "left",
            imagesLoaded: true,
        });

        function syncSlides(index) {
            subscribeSlider.select(index);
            subscribeSliderThumbs.select(index);
        }

        $(".slider .slider-nav .carousel-cell").click(function () {
            subscribeSlider.select(this.id - 1);
            subscribeSliderThumbs.select(this.id - 1);
        });
    }

    //UNBOXING VIDEO
    $(".play-btn").click(function () {
        var video = $(this).closest(".imagery").find("video").get(0);
        if (video.paused == true) {
            video.play();
            $(this).addClass("playing");
        } else {
            video.pause();
            $(this).removeClass("playing");
        }
    });

    // SUBSCRIBE BUTTONS
    $(".gsa.subscribe-main .subscribe .buttons input[type=radio]").change(function (e) {
        if (this.id == "seasonal") {
            $(".gsa.subscribe-main .subscribe .btn-add-to-cart#seasonal").css("display", "block");
            $(".gsa.subscribe-main .subscribe .btn-add-to-cart#annual").css("display", "none");

            subscribeSlider.select(this.getAttribute("data-select") ?? 0);
        } else if (this.id == "annual") {
            $(".gsa.subscribe-main .subscribe .btn-add-to-cart#annual").css("display", "block");
            $(".gsa.subscribe-main .subscribe .btn-add-to-cart#seasonal").css("display", "none");

            subscribeSlider.select(this.getAttribute("data-select") ?? 9);
        }
    });

    // GIFT BUTTONS
    $(".gsa.gift-main .gift .gift-buttons input[type=radio").change(function (e) {
        let variant = $(this).data("variant-id");
        let sellingPlan = $(this).data("selling-plan-id");
        if (!sellingPlan) {
            $(".gsa.gift-main .gift .btn-add-to-cart").removeAttr("data-selling-plan-id");
        } else {
            $(".gsa.gift-main .gift .btn-add-to-cart").attr("data-selling-plan-id", sellingPlan);
        }
        $(".gsa.gift-main .gift .btn-add-to-cart").attr("data-variant-id", variant);
        if (this.id == "oneBox") {
            $(".gsa.gift-main .gift .price-summary h5").html("$175");
            $(".gsa.gift-main .gift .price-summary span:first-of-type").html("/ 1 box");
        } else if (this.id == "twoBox") {
            $(".gsa.gift-main .gift .price-summary h5").html("$339");
            $(".gsa.gift-main .gift .price-summary span:first-of-type").html("/ 2 boxes");
        } else if (this.id == "threeBox") {
            $(".gsa.gift-main .gift .price-summary h5").html("$479");
            $(".gsa.gift-main .gift .price-summary span:first-of-type").html("/ 3 boxes");
        } else if (this.id == "fourBox") {
            $(".gsa.gift-main .gift .price-summary h5").html("$599");
            $(".gsa.gift-main .gift .price-summary span:first-of-type").html("/ 4 boxes");
        }
    });

    // ANCHOR SCROLL W/ OFFSET
    $("a[href*='#']:not([href='#']):not([href='#dio-modal'])").click(function () {
        if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") || location.hostname == this.hostname) {
            var target = $(this.hash),
                headerHeight = $(".page-header").height() + 5; // Get fixed header height

            target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");

            if (target.length) {
                $("html,body").animate(
                    {
                        scrollTop: target.offset().top - headerHeight,
                    },
                    200
                );
                return false;
            }
        }
    });

    //PDP FREE GIFT POPUP
    function showModal(el) {
        var $el = $(el);
        var variantId = $el.attr("data-variant-id");
        var sellingPlanId = $el.attr("data-selling-plan-id");

        // Set attributes for all dialogs' start-checkout buttons
        $(".start-checkout").attr("data-selling-plan-id", sellingPlanId);
        $(".start-checkout").attr("data-variant-id", variantId);

        if (variantId == 46225989304539 || variantId == 46226008998107 || variantId == 46540972032219 || variantId == 46540989726939) {
            document.getElementById("plusDialog").showModal();
        } else if (variantId == 46233927352539 || variantId == 46233927385307 || variantId == 46540967444699 || variantId == 46540980682971) {
            document.getElementById("liteDialog").showModal();
        }
    }

    //ANKER
    if ($(".anker-tabs .tabs-gallery").length) {
        $(".anker-tabs .links button").on("click", function (e) {
            var buttonId = e.target.id.split("-")[1];
            ankerTabs.select(buttonId - 1);
            $(".anker-tabs .links button").removeClass("selected");
            $(".anker-tabs .links button#link-" + buttonId).addClass("selected");
        });

        var ankerTabs = new Flickity(".anker-tabs .tabs-gallery", {
            pageDots: false,
            imagesLoaded: true,
            adaptiveHeight: true,
            on: {
                change: function (e) {
                    $(".anker-tabs .links button").removeClass("selected");
                    $(".anker-tabs .links button#link-" + (e + 1)).addClass("selected");
                    var leftPos = $(".anker-tabs .links button#link-" + (e + 1)).position().left;
                    var links = $(".anker-tabs .links");
                    links.animate({
                        scrollLeft: links.scrollLeft() + leftPos - 16,
                    });
                    //links.scrollLeft(links.scrollLeft() + leftPos - 16);
                },
            },
        });
    }

    if ($(".anker-features .features-gallery").length) {
        $(".anker-features .links button").on("click", function (e) {
            var buttonId = e.target.id.split("-")[1];
            ankerFeatures.select(buttonId - 1);
            console.log(buttonId);
            $(".anker-features .links button").removeClass("selected");
            $(".anker-features .links button#link-" + buttonId).addClass("selected");
        });

        var ankerFeatures = new Flickity(".anker-features .features-gallery", {
            pageDots: false,
            imagesLoaded: true,
            adaptiveHeight: true,
            on: {
                change: function (e) {
                    $(".anker-features .links button").removeClass("selected");
                    $(".anker-features .links button#link-" + (e + 1)).addClass("selected");
                    var leftPos = $(".anker-features .links button#link-" + (e + 1)).position().left;
                    var links = $(".anker-features .links");
                    links.animate({
                        scrollLeft: links.scrollLeft() + leftPos - 16,
                    });
                    //links.scrollLeft(links.scrollLeft() + leftPos - 16);
                },
            },
        });
    }

    // STICKY CTA
    var offsetHome = 500;
    var offsetSubscribe = 500;
    var offsetLimitedEdition = 1000;
    if ($("#seasonal.btn-add-to-cart").length) {
        var offsetSubscribe = $("#seasonal.btn-add-to-cart").offset().top;
    }
    if ($("#buy-section").length) {
        var offsetLimitedEdition = $("#buy-section").offset().top;
    }
    $(window).on("load scroll", function () {
        if ($(window).scrollTop() > offsetHome) {
            $(".sticky-cta.home").addClass("show");
        } else {
            $(".sticky-cta.home").removeClass("show");
        }

        if ($(window).scrollTop() > offsetSubscribe) {
            $(".sticky-cta.subscribe").addClass("show");
        } else {
            $(".sticky-cta.subscribe").removeClass("show");
        }

        if ($(window).scrollTop() > offsetLimitedEdition) {
            $(".sticky-cta.limited-edition").addClass("show");
        } else {
            $(".sticky-cta.limited-edition").removeClass("show");
        }
    });

    function adjustMainContentMargin() {
        var headerSections = document.querySelector(".header-sections");
        var mainContent = document.getElementById("MainContent");
        if (headerSections && mainContent) {
            mainContent.style.marginTop = headerSections.offsetHeight + "px";
        }
    }

    // Run on page load and on window resize
    window.addEventListener("DOMContentLoaded", adjustMainContentMargin);
    window.addEventListener("resize", adjustMainContentMargin);

    // const FREEGIFT_VARIANT_ID = "40509632479383";
    // const POLLING_INTERVAL_MS = 1500;

    // let timer = null;
    // let isProcessing = false;

    // async function getCart() {
    //     const res = await fetch("/cart.js");
    //     if (!res.ok) {
    //         throw new Error("Failed to fetch cart");
    //     }
    //     return res.json();
    // }

    // async function addFreeGift(variantId) {
    //     isProcessing = true;
    //     const SC = window.Rebuy?.SmartCart;
    //     if (SC && !SC._originalShow) {
    //         SC._originalShow = SC.show;
    //     }

    //     if (SC) SC.show = () => console.log("SmartCart show prevented");

    //     try {
    //         window.Rebuy.Cart.addItem(
    //             {
    //                 id: FREEGIFT_VARIANT_ID,
    //                 quantity: 1,
    //             },
    //             { success: () => console.log("Add success (silent)") }
    //         );
    //     } catch (e) {
    //         console.error("Error adding free gift:", e);
    //     } finally {
    //         setTimeout(() => {
    //             if (SC && SC._originalShow) SC.show = SC._originalShow;
    //         }, 1500);
    //         isProcessing = false;
    //     }
    // }

    // async function removeFreeGiftByKey(lineItemKey) {
    //     isProcessing = true;
    //     try {
    //         const res = await fetch("/cart/change.js", {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json", "Accept": "application/json" },
    //             credentials: "same-origin",
    //             body: JSON.stringify({ id: lineItemKey, quantity: 0 }),
    //         });
    //         if (!res.ok) throw new Error("Remove failed");
    //         const cart = await res.json();
    //         // console.log("Free gift removed:", cart);
    //     } catch (e) {
    //         console.error("Error removing free gift:", e);
    //     } finally {
    //         isProcessing = false;
    //     }
    // }

    // function schedule(ms) {
    //     clearTimeout(timer);
    //     timer = setTimeout(tick, ms);
    // }

    // async function tick() {
    //     if (isProcessing) return schedule(POLLING_INTERVAL_MS);

    //     try {
    //         const code = window.Rebuy?.SmartCart?.discount?.code?.toLowerCase() || null;
    //         const shouldHaveGift = code === "freegift";

    //         const cart = await getCart();
    //         const giftLine = cart.items.find((i) => String(i.id) === String(FREEGIFT_VARIANT_ID));

    //         if (shouldHaveGift && !giftLine) {
    //             // Add once; short backoff so cart state settles
    //             await addFreeGift(FREEGIFT_VARIANT_ID);
    //             return schedule(1500);
    //         }

    //         if (!shouldHaveGift && giftLine) {
    //             // Remove by line item key (handles properties/duplicates correctly)
    //             await removeFreeGiftByKey(giftLine.key);
    //             return schedule(1500);
    //         }
    //     } catch (e) {
    //         console.warn("Watcher error:", e);
    //     }

    //     schedule(POLLING_INTERVAL_MS);
    // }

    // // Start the polling loop
    // tick();
    // console.log("Rebuy discount check started");
})(themeVendor.Flickity);
